<template>
  <div id="app">
    <div id="content" v-show="showcontenttrue">
        <div id="topleft">
          <Comp_MenuBar :menuitems="treeflat"></Comp_MenuBar>
        </div>
        <div id="topright">
          <Comp_BreadCrumb :breadcrumb="breadcrumb"></Comp_BreadCrumb>
        </div>       
        <div id="left">
          <!-- eslint-disable -->
          <Comp_TreeView v-for="tree in trees" :key="tree.id"
                         key="tree.id"
                         :children="tree.children"
                         :level="1"
                         :catid="tree.id"
                         :name="tree.categoryname"
                         v-if="treeloaded">
          </Comp_TreeView>
          <div class="smallspacer"></div>
          <Comp_NewRootNode></Comp_NewRootNode>
        </div>
        <div id="right">    
          <Comp_ShowProducts :products="products" v-if="isShowProducts" :catname="catnameOnTop" :showheader="showheader">
          </Comp_ShowProducts>
          <Comp_AddProduct v-if="isAddProduct" :catid="Cat.id" :level="Cat.level" :catname="Cat.catname"
                           @showprodofcat="showprodofcat"></Comp_AddProduct>
          <Comp_DeleteProduct v-if="isDeleteProduct" :id="Product.id" :name="Product.name"></Comp_DeleteProduct>
          <Comp_AddSubcat v-if="isAddSubcat" :parentcategory="Subcat.parentcategory" :parentid="Subcat.parentid" :level="Subcat.level"
                          @reloadtreeview="reloadTreeView">
          </Comp_AddSubcat>
          <Comp_ProductDetails :selectedproduct="selectedproduct" @refreshalternativeproducts="refreshProductAndAlternatives"
                               :name="Product.name" :id="Product.id" :catid="Cat.id" v-if="isProductDetails"
                               @unloadaltprod="unloadaltprod" v-show="loadedproductdetails"></Comp_ProductDetails>
          <Comp_AlternativeProductDetails v-show="loadedaltprod" v-if="isAlternativeProductDetails"
                                          :selectedalternativeproduct="selectedalternativeproduct"></Comp_AlternativeProductDetails>
          <Comp_DeleteCategory v-if="isDeleteCategory" :catid="CattoDelete.id" :catname="CattoDelete.categoryname"></Comp_DeleteCategory>
          <Comp_AddRootNode v-if="isNewRootNode" @reloadtreeview="reloadTreeView"></Comp_AddRootNode>
        </div>
    </div>
  </div>
</template>

<script>
  import Comp_TreeView from "./Comp_TreeView.vue";
  import Comp_ShowProducts from "./Comp_ShowProducts.vue";
  import Comp_AddProduct from "./Comp_AddProduct.vue";
  import Comp_DeleteProduct from "./Comp_DeleteProduct.vue";
  import Comp_AddSubcat from "./Comp_AddSubcat.vue";
  import Comp_ProductDetails from "./Comp_ProductDetails.vue";
  import Comp_AlternativeProductDetails from "./Comp_AlternativeProductDetails.vue";
  import Comp_DeleteCategory from "./Comp_DeleteCategory.vue";
  import Comp_BreadCrumb from "./Comp_BreadCrumb.vue";
  import Comp_MenuBar from "./Comp_MenuBar.vue";
  import Comp_NewRootNode from "./Comp_NewRootNode.vue";
  import Comp_AddRootNode from "./Comp_AddRootNode.vue";
  import axios from 'axios';
  import qs from 'qs';
  export default {
    name: 'app',
    components: {
      Comp_TreeView,
      Comp_ShowProducts,
      Comp_AddProduct,
      Comp_DeleteProduct,
      Comp_AddSubcat,
      Comp_ProductDetails,
      Comp_AlternativeProductDetails,
      Comp_DeleteCategory,
      Comp_BreadCrumb,
      Comp_MenuBar,
      Comp_NewRootNode,
      Comp_AddRootNode
    },
    data() {
      return {
        trees: [],
        treeflat: [],
        treeloaded: false,
        products: [],
        selectedproduct: [],
        selectedprodalt: [],
        selectedalternativeproduct: [],
        loadedaltprod: true,
        loadedproductdetails: true,
        firstId: 0,
        Cat: {
          id: 0,
          level: 0,
          catname: null
        },
        Product: {
          id: 0,
          name: null
        },
        AlternativeProduct: {
          id: 0
        },
        Subcat: {
          parentid: 0,
          parentcategory: null,
          name: null,
          level: 0
        },
        CattoDelete: {
          id: 0,
          categoryname: null
        },
        breadcrumb: null,
        showcontent: false
      }
    },
    mounted() {
      Object.assign(this.$data, this.$options.data.call(this)); // reset all data and props at start
      // url was https://troubled-dove-leggings.cyclic.app
      axios.get('https://api-japie.top/meubels/treeview').then(response => {
        //var jsonData = response.data[0];
        //alert(JSON.stringify(jsonData, undefined, 2));
        //this.firstId = response.data[0].id; // get Id of root node
        for (var i = 0; i < response.data.length; i++) {
          this.trees[i] = response.data[i]; // make multiple arrays from the different root nodes
        }
        //alert(this.firstId); //--> OK, id = 1
        //this.tree = jsonData;
        this.treeloaded = true;
        this.Cat.level = 1; // set initial level to 1 for root node in breadcrumb
        //this.Cat.id = this.firstId; // set initial id to id of root node because we need to load productalternatives at this level
        this.Cat.id = this.trees[0].id;
        this.Cat.catname = null; // reset because otherwise the data are 'hanging' in memory at browser refresh
        this.$router.push("/ShowProducts");
      })
        .catch(err => {
          alert(err);
        });
      axios.get('https://api-japie.top/meubels/treeviewflat').then(response => {
        var jsonData = response.data;
        //alert(JSON.stringify(jsonData, undefined, 2));
        this.treeflat = jsonData;
      })
        .catch(err => {
          alert(err);
        });
    },
    methods: {
      showprodofcat() {
        this.$router.push('/ShowProductsofCat');
      },
      reloadTreeView() {
        //this.treeloaded = false;
        axios.get('https://api-japie.top/meubels/treeview').then(response => {
          //var jsonData = response.data[0];
          //this.firstId = response.data[0].id; // get Id of root node
          //this.tree = jsonData;
          this.trees = [];
          for (var i = 0; i < response.data.length; i++) {
            this.trees[i] = response.data[i];
          }
          //this.$router.push("/ShowProductsofCat");
          this.Cat.catname = null; // show no catname
          this.breadcrumb = null; // and no breadcrumb
          this.$router.push("/ShowProducts"); // load whole product tree
        })
          .catch(err => {
            alert(err);
          });
        axios.get('https://api-japie.top/meubels/treeviewflat').then(response => {
          var jsonData = response.data;
          //alert(JSON.stringify(jsonData, undefined, 2));
          this.treeflat = jsonData;
        })
          .catch(err => {
            alert(err);
          });
      },
      refreshProductAndAlternatives() {
        axios.get('https://api-japie.top/meubels/productandalternatives?productid=' + this.Product.id).then(response => {
          this.selectedproduct = response.data;
        })
          .catch(err => {
            alert(err);
          })
      },
      unloadaltprod() {
        this.loadedaltprod = false;
      },
      getCrumb() {
        const body = {
          "id": this.Cat.id,
          "level": this.Cat.level,
          "catname": this.Cat.catname
        }
        //alert(JSON.stringify(body, undefined, 2));
        var url = 'https://api-japie.top/meubels/getcrumb';
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: qs.stringify(body),
          url
        };
        axios(options).then(response => {
          var jsonData = response.data;
          this.breadcrumb = jsonData;
          //alert(JSON.stringify(this.breadcrumb, undefined, 2));
        })
          .catch(err => {
            alert(err);
          });
      }
    },
    computed: {
      showcontenttrue() {
        return this.showcontent;
      },
      isShowProducts() {
        if (this.$route.name == 'ShowProducts') {
          axios.get('https://api-japie.top/meubels/getallproducts').then(response => {
            var jsonData = response.data;
            this.products = jsonData;
            this.showcontent = true; // tree is loaded, products are loaded so show div content
            //alert(JSON.stringify(this.products, undefined, 2));
          })
            .catch(err => {
              alert(err);
            })
          return this.$route.name == 'ShowProducts'
        }

        if (this.$route.name == 'ShowProductsofCat') {
          if ((this.$route.query.id) && (this.$route.query.level) && (this.$route.query.category)) {
            this.Cat.id = this.$route.query.id;
            this.Cat.level = this.$route.query.level;
            this.Cat.catname = this.$route.query.category;
          }
          //alert("Cat Id of this node: " + this.Cat.id + " Level of this node: " + this.Cat.level);
          axios.get('https://api-japie.top/meubels/getproducts?CatID=' + this.Cat.id).then(response => {
            var jsonData = response.data;
            this.products = jsonData;
            //alert(JSON.stringify(jsonData, undefined, 2));
          })
            .catch(err => {
              alert(err);
            })
          return this.$route.name == 'ShowProductsofCat';
        }
      },
      isAddProduct() {
        if (this.$route.name == 'AddProduct') {
          this.Cat.id = this.$route.query.id;
          this.Cat.level = this.$route.query.level;
          this.Cat.catname = this.$route.query.category;
          return this.$route.name == 'AddProduct'
        }
      },
      isDeleteProduct() {
        if (this.$route.name == 'DeleteProduct') {
          this.Product.id = this.$route.query.Id;
          this.Product.name = this.$route.query.ProdName;
          //alert(this.Product.id + " " + this.Product.name);
          return this.$route.name == 'DeleteProduct'
        }
      },
      isAddSubcat() {
        if (this.$route.name == 'AddSubcat') {
          this.Subcat.parentid = this.$route.query.id;
          this.Subcat.parentcategory = this.$route.query.parentcategory;
          this.Subcat.level = this.$route.query.level;
          //alert(this.Product.id + " " + this.Product.name);
          return this.$route.name == 'AddSubcat'
        }
      },
      catnameOnTop() {
        var catname = this.Cat.catname;
        if (catname == null) {
          return 'All products';
        }
        else {
          return catname;
        }
      },
      isProductDetails() {
        if (this.$route.name == 'ProductDetails') {
          this.loadedproductdetails = false;
          if ((this.$route.query.Id) && (this.$route.query.ProdName)) {
            this.Product.id = this.$route.query.Id;
            this.Product.name = this.$route.query.ProdName;
          }
          //alert(this.Product.id);
          axios.get('https://api-japie.top/meubels/productandalternatives?productid=' + this.Product.id).then(response => {
            this.selectedproduct = response.data;
            this.loadedproductdetails = true;
          })
            .catch(err => {
              alert(err);
            })
          return this.$route.name == 'ProductDetails'
        }
      },
      isAlternativeProductDetails() {
        if (this.$route.name == 'AlternativeProductDetails') {
          this.AlternativeProduct.id = this.$route.query.Id;
          axios.get('https://api-japie.top/meubels/productandalternatives?productid=' + this.AlternativeProduct.id).then(response => {
            this.selectedalternativeproduct = response.data;
            this.loadedaltprod = true;
          })
            .catch(err => {
              alert(err);
            })
          return this.$route.name == 'AlternativeProductDetails'
        }
      },
      isDeleteCategory() {
        if (this.$route.name == 'DeleteCategory') {
          this.CattoDelete.id = this.$route.query.id;
          this.CattoDelete.categoryname = this.$route.query.category;
          return this.$route.name == 'DeleteCategory'
        }
      },
      isNewRootNode() {
        if (this.$route.name == 'NewRootNode') {
          return this.$route.name == 'NewRootNode'
        }
      }
    },
    watch: {
      $route(to, from) {
        if (this.$route.name == 'DeleteProd') {
          var id_to_delete = this.$route.query.Id;
          axios.post('https://api-japie.top/meubels/deleteproduct?Id=' + id_to_delete).then(response => {
            this.$router.push('/ShowProductsofCat');
          })
            .catch(err => {
              alert(err);
            })
        }
        if (this.$route.name == 'DeleteCat') {
          var cat_to_delete = this.$route.query.CategoryId;
          //alert(cat_to_delete);
          axios.post('https://api-japie.top/meubels/deletecategory?CatID=' + cat_to_delete).then(response => {
            this.reloadTreeView();
          })
            .catch(err => {
              alert(err);
            })
        }
        if (this.$route.name == 'ShowProductsofCat') {
          if ((this.$route.query.id) && (this.$route.query.level) && (this.$route.query.category)) {
            this.Cat.id = this.$route.query.id;
            this.Cat.level = this.$route.query.level;
            this.Cat.catname = this.$route.query.category;
          }
          if (this.Cat.level == 1) {
            this.breadcrumb = null; // hide breadcrumb at root level because it has no functionality
          }
          else {
            this.getCrumb();
          }
        }
      }
    }
}
</script>

<style>
  body {
    font-family: Arial;
    overflow: visible;
  }

  #left {
    width: 380px;
    float: left;
    border: solid 0px;
    height: calc(90vh);
    overflow-y: scroll;
    position: fixed;
    background-color: white;
    margin-top: 50px;
  }

  #right {
    width: calc(100% - 380px);
    float: right;
    border: solid 0px;
    padding-left: 20px;
    margin-top: 50px;
  }

  #topleft {
    width: 380px;
    border: solid 0px;
    height: 50px;
    position: fixed;
    top: 0;
    background-color: white;
  }

  #topright {
    width: calc(100% - 380px);
    left: 388px;
    border: solid 0px;
    height: 40px;
    position: fixed;
    top: 0;
    padding-top: 10px;
    background-color: white;
  }

  .smallspacer {
      height: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue